module.exports = __webpack_public_path__ + "img/icon-02.881b62f3.png";